import { t } from '../i18n/es';

/** Hint for portrait phones (GDD §15.8). Shown by CSS only when it is portrait with a coarse pointer. */
export function mountRotateHint(root: HTMLElement): void {
  const hint = document.createElement('p');
  hint.className = 'rotate-hint';
  hint.setAttribute('role', 'status');
  hint.textContent = t('ui.view.rotate');
  root.append(hint);
}
